// extracted by mini-css-extract-plugin
export default {"sampleProjectMissing":"SampleProjectItem_sampleProjectMissing__DTrur","project":"SampleProjectItem_project__Hb++5"};